// extracted by mini-css-extract-plugin
module.exports = {"s1e34fq0":"s1e34fq0"};